import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import '../styles/loadsku.css';
import { useNavigate } from 'react-router-dom';


import { API_BASE } from '../config';
const LoadSku = () => {
  const { token } = useAuth(); // Accede al token desde el contexto de autenticación
  const [file, setFile] = useState(null); // Estado para almacenar el archivo seleccionado
  const [loading, setLoading] = useState(false); // Estado para mostrar el estado de carga
  const [error, setError] = useState(null); // Estado para manejar errores
  const navigate = useNavigate(); // Inicializa useNavigate
  // Función para manejar el cambio de archivo
  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  // Función para manejar el envío del formulario
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!file) {
      setError('Por favor, selecciona un archivo.');
      return;
    }
    setLoading(true);
    setError(null);

    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await fetch(`${API_BASE}/upload-sku-file/`, {
        method: 'POST',
        headers: {
          'Authorization': `Token ${token}`, // Enviar el token en el header
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error('Error al cargar el archivo');
      }

      await response.json();
      alert('Archivo cargado con éxito');
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="load-sku-container">
                                <button className="adminproductos-back-button" onClick={() => navigate(`/init`)}>
                &#8592;
            </button>
      <h1 className="load-sku-title">Cargar Archivo SKU</h1>

      <form onSubmit={handleSubmit} className="load-sku-form">
        <input
          type="file"
          onChange={handleFileChange}
          accept=".xls,.xlsx"
          className="load-sku-file-input"
        />
        {error && <div className="load-sku-error">{error}</div>}
        <button type="submit" className="load-sku-submit-button" disabled={loading}>
          {loading ? 'Cargando...' : 'Subir Archivo'}
        </button>
      </form>
    </div>
  );
};

export default LoadSku;
